:host {
  --ds-choice-popup-min-inline-size: var(--dimension-menu-width-xs);

  display: inline-block;
  min-inline-size: 0;
  max-inline-size: var(--dimension-menu-width-xs);
}

ds-select {
  display: block;
  min-inline-size: 0;
  max-inline-size: 100%;
}

.table-saved-views__dialog-actions {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: var(--dimension-space-100);
}
